import { useCountUp } from '@/hook/useCountUp';
import { cn } from '@/lib/cn';

interface ChartRankProps {
  rank: number;
  className?: string;
}

/** A chart position. It counts up when the chart around it is replaced, which
 * is what makes the Global/Friends switch read as a new chart rather than new
 * text. Rank 1 is gold; the rest are faint. */
export function ChartRank({ rank, className }: ChartRankProps) {
  const value = useCountUp(rank);
  return (
    <span className={cn('font-semibold tabular-nums', rank === 1 ? 'text-acc' : 'text-faint', className)}>
      {value}
    </span>
  );
}
